window.dn = window.dn || {};

/**
 * All code related to storage
 */

(function (storage, $, undefined)
{
    // Takes an ArrayBuffer and converts it to a string for storage
    bufferToString = function(buffer) 
    {
        return window.btoa(
            String.fromCharCode.apply(null, new Uint8Array(buffer))
        )
    }

    /**
     * Clears out the specified values from the local storage
     * 
     * @param {string} userKey - The user's key
     * @param {string} namespace - The custom namespace 
     */
    storage.Clear = function(userKey, namespace)
    {
        let key = userKey + ":" + namespace;
        localStorage.setItem(key, null);
    };

    /**
     * Looks through the local storage data and removes any items which
     * start with the key of the current user (to be used on log-out)
     */
    storage.ClearUser = function()
    {
        var keys = Object.keys(localStorage),
        i = keys.length;//reverse to avoid concurrency problems

        while ( i-- ) 
        {
            let currentKey = keys[i]
            if (currentKey.startsWith(dn.user.UserKey))
            {
                localStorage.removeItem(currentKey)
            }            
        }
    };

    /**
     * Looks in local storage for a value for the current user
     * with the provided namespace
     * 
     * @param {string} userKey - The user's key
     * @param {string} namespace - The custom namespace 
     */
    // TODO: async function not compatible with older browsers.
    // storage.RetrieveLocal = async function(userKey, namespace)
    // {
    //     let key = userKey + ":" + namespace;
    //     let storedItem = localStorage.getItem(key);

    //     if (storedItem === null) return null;

    //     let storedJson = JSON.parse(storedItem);

    //     if (storedJson === "" || storedJson === null)
    //         return

    //     let cipher = dn.crypto.StringToArrayBuffer(storedJson.cipher);
    //     let iv = dn.crypto.StringToArrayBuffer(storedJson.iv);

    //     let timestamp = storedJson.ts;//TODO - care about this???

    //     let response = await dn.crypto.Decrypt(cipher, iv)
    //     return JSON.parse(response)//it's stringified going in, so we need to unwrap it
    // };

    /**
     * Stores the passed object in local storage using the key and namespace
     * as unique identifiers
     * 
     * @param {string} userKey - The user's key
     * @param {string} namespace - The custom namespace 
     * @param {string} object - The object to store (will be stringified by JSON)
     */
    // TODO: async function not compatible with older browsers.
    // storage.StoreLocal = async function(userKey, namespace, object)
    // {
    //     let key = userKey + ":" + namespace;
    //     const { cipher, iv } = await dn.crypto.Encrypt(JSON.stringify(object))

    //     localStorage.setItem(
    //         key, 
    //         JSON.stringify({
    //             ts:new Date(), 
    //             cipher: bufferToString(cipher),
    //             iv: bufferToString(iv),
    //         }
    //     ))
    // };

}(window.dn.storage = window.dn.storage || {}, jQuery));